var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "pagination-wrap" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("b-pagination", {
                  staticStyle: { "padding-bottom": "8px" },
                  attrs: {
                    align: "left",
                    size: "md",
                    "total-rows": _vm.availablePagination.total,
                    "per-page": _vm.availablePagination.perPage
                  },
                  on: { change: _vm.changeAvailablePage },
                  model: {
                    value: _vm.availablePagination.currentPage,
                    callback: function($$v) {
                      _vm.$set(_vm.availablePagination, "currentPage", $$v)
                    },
                    expression: "availablePagination.currentPage"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col text-right" },
              [
                _c("p", { staticClass: "inline-block" }, [
                  _vm._v("Rows per page")
                ]),
                _vm._v(" "),
                _c("b-form-select", {
                  staticClass: "rows-select",
                  attrs: {
                    options: [
                      { text: 5, value: 5 },
                      { text: 10, value: 10 },
                      { text: 15, value: 15 },
                      { text: 25, value: 25 },
                      { text: 50, value: 50 },
                      { text: 100, value: 100 }
                    ],
                    cols: "1"
                  },
                  on: {
                    input: function() {
                      return _vm.changeAvailablePage(1)
                    }
                  },
                  model: {
                    value: _vm.availablePagination.perPage,
                    callback: function($$v) {
                      _vm.$set(_vm.availablePagination, "perPage", $$v)
                    },
                    expression: "availablePagination.perPage"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _vm.pagination
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("b-pagination", {
                      staticStyle: { "padding-bottom": "8px" },
                      attrs: {
                        align: "left",
                        size: "md",
                        "total-rows": _vm.pagination.total,
                        "per-page": _vm.pagination.perPage
                      },
                      on: {
                        change: function(value) {
                          return _vm.changeSelectedPage({ page: value })
                        }
                      },
                      model: {
                        value: _vm.pagination.currentPage,
                        callback: function($$v) {
                          _vm.$set(_vm.pagination, "currentPage", $$v)
                        },
                        expression: "pagination.currentPage"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col text-right" },
                  [
                    _c("p", { staticClass: "inline-block" }, [
                      _vm._v("Rows per page")
                    ]),
                    _vm._v(" "),
                    _c("b-form-select", {
                      staticClass: "rows-select",
                      attrs: {
                        options: [
                          { text: 5, value: 5 },
                          { text: 10, value: 10 },
                          { text: 15, value: 15 },
                          { text: 25, value: 25 },
                          { text: 50, value: 50 },
                          { text: 100, value: 100 }
                        ],
                        cols: "1"
                      },
                      on: {
                        input: function(value) {
                          return _vm.changeSelectedPage({ per_page: value })
                        }
                      },
                      model: {
                        value: _vm.pagination.perPage,
                        callback: function($$v) {
                          _vm.$set(_vm.pagination, "perPage", $$v)
                        },
                        expression: "pagination.perPage"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-deck multi-select" }, [
      _c("div", { staticClass: "col p-0" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-header d-flex flex-row align-items-end" },
            [
              !_vm._.isEmpty(_vm.customFilters)
                ? _c(
                    "ul",
                    { staticClass: "multi-select-filter list-unstyled mb-0" },
                    _vm._l(_vm.customFilters, function(filter) {
                      return _c("custom-filter-component", {
                        key: filter.name,
                        attrs: {
                          changeFilter: _vm.changeFilter,
                          config: filter
                        }
                      })
                    }),
                    1
                  )
                : _c("div", { staticClass: "card-header-title" }, [
                    _c("b", [_vm._v("Available")])
                  ]),
              _vm._v(" "),
              _vm._.has(_vm.config, "searchable") &&
              _vm._.get(_vm.config, "searchable")
                ? _c(
                    "form",
                    {
                      class: [
                        "card-header-search ml-auto",
                        _vm._.isEmpty(_vm.customFilters) ? "mt-0" : ""
                      ],
                      on: { submit: _vm.changeAvailableSearch }
                    },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.unselectedFilter,
                              expression: "unselectedFilter"
                            }
                          ],
                          staticClass: "form-control search",
                          attrs: {
                            type: "text",
                            placeholder: "Search...",
                            role: "combobox"
                          },
                          domProps: { value: _vm.unselectedFilter },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.unselectedFilter = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(0)
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          !_vm.loadingAvailable
            ? _c(
                "div",
                { staticClass: "list-group" },
                _vm._l(_vm.unselected, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "list-group-item list-group-item-action",
                      attrs: { href: "javascript:void(0)", target: "_self" }
                    },
                    [
                      !_vm.noImage
                        ? _c("img", { attrs: { src: _vm.getImageLink(item) } })
                        : _vm._e(),
                      _vm._v(" "),
                      item.link
                        ? _c("a", {
                            staticClass: "list-group-item-label",
                            attrs: { href: item.link },
                            domProps: { innerHTML: _vm._s(item.name) }
                          })
                        : _c("span", {
                            staticClass: "list-group-item-label",
                            domProps: { innerHTML: _vm._s(item.name) }
                          }),
                      _vm._v(" "),
                      _vm._.includes(_vm.unselectedProcessingIds, item.id)
                        ? _c(
                            "button",
                            {
                              class: [
                                "btn",
                                "btn-light",
                                "btn-rounded",
                                "btn-sm",
                                "btn-arrow"
                              ],
                              attrs: { type: "button", disabled: "" }
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("more_horiz")
                              ])
                            ]
                          )
                        : _c(
                            "button",
                            {
                              class: [
                                "btn",
                                "btn-light",
                                "btn-rounded",
                                "btn-sm",
                                "btn-arrow"
                              ],
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.select(item)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("arrow_forward")
                              ])
                            ]
                          )
                    ]
                  )
                }),
                0
              )
            : _c(
                "div",
                { staticStyle: { margin: "3rem auto" } },
                [_c("vue-spinner")],
                1
              )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col p-0" }, [
        _c(
          "div",
          { staticClass: "card" },
          [
            _c(
              "div",
              { staticClass: "card-header d-flex flex-row align-items-end" },
              [
                _vm._m(1),
                _vm._v(" "),
                _vm._.has(_vm.config, "searchable") &&
                _vm._.get(_vm.config, "searchable")
                  ? _c(
                      "form",
                      {
                        class: ["card-header-search ml-auto", "mt-0"],
                        on: { submit: _vm.changeSelectedSearch }
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedFilter,
                                expression: "selectedFilter"
                              }
                            ],
                            staticClass: "form-control search",
                            attrs: {
                              type: "text",
                              placeholder: "Search...",
                              role: "combobox"
                            },
                            domProps: { value: _vm.selectedFilter },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.selectedFilter = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(2)
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.updating || !_vm.loading
              ? _c(
                  "draggable",
                  {
                    staticClass: "list-group",
                    attrs: { options: { disabled: !_vm.priorityField } },
                    on: { end: _vm.changePriority },
                    model: {
                      value: _vm.selected,
                      callback: function($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected"
                    }
                  },
                  _vm._l(_vm.filteredSelected, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "list-group-item list-group-item-action",
                        attrs: { href: "javascript:void(0)", target: "_self" }
                      },
                      [
                        _vm.priorityField
                          ? _c(
                              "i",
                              { staticClass: "material-icons drag-icon" },
                              [_vm._v("view_headline")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.noImage
                          ? _c("img", {
                              attrs: { src: _vm.getImageLink(item) }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.link
                          ? _c("a", {
                              staticClass:
                                "list-group-item-label flex-shrink-1",
                              attrs: { href: item.link },
                              domProps: { innerHTML: _vm._s(item.name) }
                            })
                          : _c("span", {
                              staticClass: "list-group-item-label",
                              domProps: { innerHTML: _vm._s(item.name) }
                            }),
                        _vm._v(" "),
                        _vm._.includes(_vm.selectedProcessingIds, item.id)
                          ? _c(
                              "button",
                              {
                                class: [
                                  "btn",
                                  "btn-light",
                                  "btn-rounded",
                                  "btn-sm",
                                  "btn-arrow"
                                ],
                                attrs: { type: "button", disabled: "" }
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("more_horiz")
                                ])
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-light btn-rounded btn-sm btn-arrow",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.deselect(item)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("arrow_back")
                                ])
                              ]
                            )
                      ]
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  { staticStyle: { margin: "3rem auto" } },
                  [_c("vue-spinner")],
                  1
                )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-navy px-2", attrs: { type: "submit" } },
        [
          _c("i", { staticClass: "material-icons md-18 mt-1" }, [
            _vm._v("search")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header-title" }, [
      _c("b", [_vm._v("Selected")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-navy px-2", attrs: { type: "submit" } },
        [
          _c("i", { staticClass: "material-icons md-18 mt-1" }, [
            _vm._v("search")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0543864d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0543864d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/LazyloadingMultiSelectComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0543864d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/LazyloadingMultiSelectComponent.vue
// module chunks = 0